import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_MERCHANT: string = '[ecommerce merchant] Load Ecommerce Merchant';
export const LOAD_ECOMMERCE_MERCHANT_SUCCESS: string = '[ecommerce merchant] Load Ecommerce Merchant Success';
export const LOAD_ECOMMERCE_MERCHANT_FAIL: string = '[ecommerce merchant] Load Ecommerce Merchant Fail';

export const LOAD_ECOMMERCE_ACTIVE_MERCHANT: string = '[ecommerce active merchant] Load Ecommerce Active Merchant';
export const LOAD_ECOMMERCE_ACTIVE_MERCHANT_SUCCESS: string = '[ecommerce active merchant] Load Ecommerce Active Merchant Success';
export const LOAD_ECOMMERCE_ACTIVE_MERCHANT_FAIL: string = '[ecommerce active merchant] Load Ecommerce Active Merchant Fail';

export const LOAD_ECOMMERCE_MERCHANT_HASH: string = '[ecommerce merchant hash] Load Ecommerce Merchant Hash';
export const LOAD_ECOMMERCE_MERCHANT_HASH_SUCCESS: string = '[ecommerce merchant hash] Load Ecommerce Merchant Hash Success';
export const LOAD_ECOMMERCE_MERCHANT_HASH_FAIL: string = '[ecommerce merchant hash] Load Ecommerce Merchant Hash Fail';

export const LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT: string = '[ecommerce merchant payouts amount] Load Ecommerce Merchant Payouts Amount';
export const LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT_SUCCESS: string = '[ecommerce merchant payouts amount] Load Ecommerce Merchant Payouts Amount Success';
export const LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT_FAIL: string = '[ecommerce merchant payouts amount] Load Ecommerce Merchant Payouts Amount Fail';


export const LOAD_ECOMMERCE_WORKSPACE_MERCHANTS: string = '[ecommerce workspace merchants] Load Ecommerce Workspace Merchants';
export const LOAD_ECOMMERCE_WORKSPACE_MERCHANTS_SUCCESS: string = '[ecommerce workspace merchants] Load Ecommerce Workspace Merchants Success';
export const LOAD_ECOMMERCE_WORKSPACE_MERCHANTS_FAIL: string = '[ecommerce workspace merchants] Load Ecommerce Workspace Merchants Fail';


export class LoadEcommerceMerchant implements Action {
  readonly type: string = LOAD_ECOMMERCE_MERCHANT;

  constructor(public payload: { websiteId: number, env: string }) {
  }
}

export class LoadEcommerceMerchantSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_MERCHANT_SUCCESS;

  constructor(public payload: {
    merchantId: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceMerchantFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_MERCHANT_FAIL;

  constructor(public payload: any) {
  }

}


export class LoadEcommerceActiveMerchant implements Action {
  readonly type: string = LOAD_ECOMMERCE_ACTIVE_MERCHANT;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceActiveMerchantSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_ACTIVE_MERCHANT_SUCCESS;

  constructor(public payload: {
    merchant: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceActiveMerchantFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_ACTIVE_MERCHANT_FAIL;

  constructor(public payload: any) {
  }

}

export class LoadEcommerceMerchantHash implements Action {
  readonly type: string = LOAD_ECOMMERCE_MERCHANT_HASH;

  constructor(public payload: { websiteId: number, merchantId: string, env: string }) {
  }
}

export class LoadEcommerceMerchantHashSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_MERCHANT_HASH_SUCCESS;

  constructor(public payload: {
    existingMerchantHash: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceMerchantHashFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_MERCHANT_HASH_FAIL;

  constructor(public payload: any) {
  }

}


export class LoadEcommerceMerchantPayoutsAmount implements Action {
  readonly type: string = LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT;

  constructor(public payload: { websiteId: number, merchantId: string, env: string }) {
  }
}

export class LoadEcommerceMerchantPayoutsAmountSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT_SUCCESS;

  constructor(public payload: {
    payoutsAmount: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceMerchantPayoutsAmountFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT_FAIL;

  constructor(public payload: any) {
  }

}


export class LoadEcommerceWorkspaceMerchants implements Action {
  readonly type: string = LOAD_ECOMMERCE_WORKSPACE_MERCHANTS;
}

export class LoadEcommerceWorkspaceMerchantsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_WORKSPACE_MERCHANTS_SUCCESS;

  constructor(public payload: {
    merchants: any,
    loaded?: boolean,
    loading?: boolean
  }) {
  }

}

export class LoadEcommerceWorkspaceMerchantsFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_WORKSPACE_MERCHANTS_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceMerchantAction = LoadEcommerceMerchant | LoadEcommerceMerchantSuccess | LoadEcommerceMerchantFail
  | LoadEcommerceActiveMerchant | LoadEcommerceActiveMerchantSuccess | LoadEcommerceActiveMerchantFail
  | LoadEcommerceWorkspaceMerchants | LoadEcommerceWorkspaceMerchantsSuccess | LoadEcommerceWorkspaceMerchantsFail
  | LoadEcommerceMerchantHash | LoadEcommerceMerchantHashSuccess | LoadEcommerceMerchantHashFail
  | LoadEcommerceMerchantPayoutsAmount | LoadEcommerceMerchantPayoutsAmountSuccess | LoadEcommerceMerchantPayoutsAmountFail;
